import React from 'react';
import { useGetUserQuestionsQuery } from '../../apis';
import { useParams } from 'react-router-dom';
import { QuestionCard } from '../../components/QuestionCard/QuestionCard.tsx';
import { Spinner, SpinnerVariants } from '../../UI';

export const UserQuestions: React.FC = () => {

  const { userId } = useParams<{ userId: string }>();

  const { data, isLoading } = useGetUserQuestionsQuery(userId!);

  if (isLoading) {
    return <div className='flex justify-center'>
      <Spinner variant={SpinnerVariants.SMALL_CIRCLE} />
    </div>;
  }

  return (
    <>
      {
        data?.length === 0
          ? <div className='text-white mt-app-base text-app-lg flex justify-center'>
            <p>You haven&apos;t post any pinions yet</p>
          </div>
          : null
      }
      {
        data && data.length > 0
          ? data.map((question) => {
            return <QuestionCard data={question} key={question.questionId} />;
          })
          : null
      }
    </>
  );
};
